import Hero from "../components/Hero";
import Navbar from "../components/Navbar"
import ContactImg from "../Assets/13B.jpeg"
import Footer from "../components/Footer";
import ContactForm from "../components/ContctForm";
import FloatingButton from "../components/FloatingButton";
function Contact(){
    return (
        <>
             <Navbar/>
       <Hero
   cName="hero-mid"
   heroImg={ContactImg}
   title="Contact"
   btnClass="hide"
   />
   <ContactForm/>
   <FloatingButton/>
   <Footer/>
        </>
    )
    }
    
    export default Contact;